module.exports = __webpack_public_path__ + "static/media/private-label.9c05d102.png";